<template>
    <ModalFormCard :action='action' :submittedCallback="submittedCallback" class="modal-default">
        <template #title>Domain purchase</template>

        <template #default="{ saving, errors }">
            <input type="hidden" name="company_id" :value="editingModel.id" />

            <Input
                v-model:value="value.domain"
                name="domain_name"
                label="Check domain availability"
                class="col-span-2"
                :disabled="saving"
            >
                <template v-if="showBuy" #right>
                    <IconTick v-if="canBuy" class="w-5 h-5 stroke-green-600 mr-3" />
                    <IconClose v-if="!canBuy" class="w-4 h-4 stroke-red-700 mr-3" />
                </template>
            </Input>

            <div class="modal-buttons">
                <ButtonSaving class="button-black h-12 default" 
                    :saving="saving" 
                    :disabled="(!canBuy && showBuy)"
                >
                    {{ showBuy ? 'Buy domain' : 'Search' }}
                </ButtonSaving>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
import Modal from '~/mixins/modal.js'

export default {
    mixins: [Modal],

    data() {
        return {
            value: { domain: this.editingModel.name.toLowerCase().replace(/[^a-z]/gi, '') + '.co.uk' },
            domain: null,
        }
    },

    methods: {
        submittedCallback(res, event) {
            if (!this.showBuy) {
                this.domain = res.domain
            } else {
                this.$event.$emit('modal-form-completed')
				this.$event.$emit('modal-close')
            }
        },
    },

    computed: {
        showBuy() {
            return this.domain != null && this.domain.domain == this.value.domain
        },

        canBuy() {
            return this.showBuy && this.domain.premium == false && this.domain.available == true
        },

        action() {
            return this.showBuy ? '/admin/domain/buy' : '/admin/domain/search'
        }
    },
}
</script>
